import React from "react";
import { Box, Typography, styled } from "@mui/material";
import PropTypes from "prop-types";
import { IoIosCheckmark, IoIosDoneAll, IoMdSnow } from "react-icons/io";
import { getTimeFromUnixTimeStamp } from "../../../../../helpers";

export const Message = ({
  id,
  authorColor,
  chatType,
  postingMessage,
  lastMessage,
  errorPostMessage,
  messageObject,
}) => {
  const { author, isAuthor, message, createdAt, wasDelivered, wasRead } =
    messageObject;

  const authorName = !isAuthor ? author.username : "";

  return (
    <MessageRow isMyMessage={isAuthor}>
      <MessageContainer id={id} isMyMessage={isAuthor}>
        {!isAuthor &&
          chatType === "group" &&
          lastMessage &&
          lastMessage.author.username !== authorName && (
            <MessageUsername authorColor={authorColor}>
              {authorName}
            </MessageUsername>
          )}

        <MessageText>
          {message}
          {isAuthor && postingMessage && !wasDelivered && !wasRead && (
            <StyledIoMdSnow size={18} /> // Show snowflake while posting
          )}
          {isAuthor && !postingMessage && !wasDelivered && !wasRead && (
            <StyledIoIosCheckmark size={18} /> // One tick when at the backend
          )}
          {isAuthor && !postingMessage && wasDelivered && !wasRead && (
            <StyledIoIosDoneAll size={18} /> // Two ticks when delivered
          )}
          {isAuthor && !postingMessage && wasDelivered && wasRead && (
            <StyledIoIosDoneAll color={"green"} size={18} /> // Two ticks when read
          )}
          <Time>{getTimeFromUnixTimeStamp(createdAt)}</Time>
        </MessageText>
      </MessageContainer>
    </MessageRow>
  );
};

Message.propTypes = {
  // message: PropTypes.string.isRequired,
  // timestamp: PropTypes.string.isRequired,
  // isAuthor: PropTypes.bool.isRequired,
  // wasDelivered: PropTypes.bool.isRequired,
  // wasRead: PropTypes.bool.isRequired,
};

const MessageRow = styled(Box, {
  shouldForwardProp: (prop) => prop !== "isMyMessage",
})(({ isMyMessage }) => ({
  width: "100%",
  display: "flex",
  justifyContent: isMyMessage ? "flex-end" : "flex-start",
}));

const MessageContainer = styled(Box, {
  shouldForwardProp: (prop) => prop !== "isMyMessage",
})(({ isMyMessage, theme }) => ({
  minWidth: "50px",
  maxWidth: "70%",
  padding: "12px 16px",
  border: isMyMessage
    ? "1px solid rgba(33, 150, 243, 0.2)"
    : "1px solid rgba(0, 0, 0, 0.08)",
  borderRadius: isMyMessage ? "18px 18px 4px 18px" : "18px 18px 18px 4px",
  margin: "8px 16px",
  background: isMyMessage 
    ? (theme?.userMessageColor || "#FFBCBD") 
    : (theme?.receivedMessageColor || "#F0F0F0"),
  wordBreak: "break-word",
  boxShadow: isMyMessage
    ? "0 2px 8px rgba(33, 150, 243, 0.15)"
    : "0 2px 8px rgba(0, 0, 0, 0.1)",
  position: "relative",
  "&:hover": {
    boxShadow: isMyMessage
      ? "0 4px 12px rgba(33, 150, 243, 0.25)"
      : "0 4px 12px rgba(0, 0, 0, 0.15)",
    transform: "translateY(-1px)",
    transition: "all 0.2s ease-in-out",
  },
  transition: "all 0.2s ease-in-out",
}));

const MessageUsername = styled(Typography)({
  fontSize: "12px",
  fontWeight: 600,
  color: (props) => props.authorColor,
  marginBottom: "4px",
  opacity: 0.8,
});

const MessageText = styled(Typography)(({ theme }) => ({
  fontSize: "14px",
  fontWeight: 500,
  color: theme?.chatFontColor || "#2C3E50",
  whiteSpace: "pre-line",
  lineHeight: 1.4,
}));

const Time = styled(Typography)({
  fontWeight: "normal",
  fontSize: "11px",
  color: "#7F8C8D",
  marginTop: "6px",
  marginLeft: "8px",
  float: "right",
  opacity: 0.7,
});

const StyledIoMdSnow = styled(IoMdSnow)({
  marginLeft: "8px",
  float: "right",
  color: "#3498DB",
  opacity: 0.8,
});

const StyledIoIosCheckmark = styled(IoIosCheckmark)({
  marginLeft: "8px",
  float: "right",
  color: "#95A5A6",
  opacity: 0.8,
});

const StyledIoIosDoneAll = styled(IoIosDoneAll)({
  marginLeft: "8px",
  float: "right",
  color: "#27AE60",
  opacity: 0.9,
});
